"use strict";

module.exports = function pi() {
  //  discuss at: http://locutus.io/php/pi/
  // original by: Onno Marsman (https://twitter.com/onnomarsman)
  // improved by: dude
  //   example 1: pi(8723321.4)
  //   returns 1: 3.141592653589793

  return 3.141592653589793; // Math.PI
};
//# sourceMappingURL=pi.js.map


//////////////////
// WEBPACK FOOTER
// ./~/locutus/php/math/pi.js
// module id = j797
// module chunks = 0